import { render, staticRenderFns } from "./DoctorStore.vue?vue&type=template&id=fbf062ae&scoped=true&"
import script from "./DoctorStore.vue?vue&type=script&lang=js&"
export * from "./DoctorStore.vue?vue&type=script&lang=js&"
import style0 from "./DoctorStore.vue?vue&type=style&index=0&id=fbf062ae&lang=scss&scoped=true&"
import style1 from "./DoctorStore.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf062ae",
  null
  
)

export default component.exports